// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpLayoutIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpLayoutIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpLayoutIconOutlined = function DrrpLayoutIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpLayoutIconOutlinedSvg
  }));
};

DrrpLayoutIconOutlined.displayName = 'DrrpLayoutIconOutlined';
export default React.forwardRef(DrrpLayoutIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpLayoutIconOutlined.js
// module id = 2565
// module chunks = 0